import type { CSSProperties } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const WRAP: CSSProperties = {
  display: "flex",
  gap: 8,
  overflowX: "auto",
  padding: "12px 24px",
  scrollbarWidth: "none",
};
const PILL_BASE: CSSProperties = {
  flexShrink: 0,
  borderRadius: 999,
  padding: "8px 14px",
  fontFamily: "var(--font-body)",
  fontSize: 13,
  textDecoration: "none",
  border: "1px solid var(--d-violet)",
  color: "var(--d-violet)",
  background: "transparent",
  whiteSpace: "nowrap",
};
const PILL_ACTIVE: CSSProperties = {
  ...PILL_BASE,
  background: "var(--d-violet)",
  color: "#fff",
};

type TabKey =
  | "tabs.economics"
  | "tabs.usage"
  | "tabs.products"
  | "tabs.llm_config"
  | "tabs.app_config"
  | "tabs.free_tier"
  | "tabs.users"
  | "tabs.feedback"
  | "tabs.generations"
  | "tabs.audit_log"
  | "tabs.flags";

interface TabDef {
  to: string;
  key: TabKey;
}

const TABS: TabDef[] = [
  { to: "/admin/economics", key: "tabs.economics" },
  { to: "/admin/usage", key: "tabs.usage" },
  { to: "/admin/products", key: "tabs.products" },
  { to: "/admin/llm-config", key: "tabs.llm_config" },
  { to: "/admin/app-config", key: "tabs.app_config" },
  { to: "/admin/flags", key: "tabs.flags" },
  { to: "/admin/free-tier", key: "tabs.free_tier" },
  { to: "/admin/users", key: "tabs.users" },
  { to: "/admin/feedback", key: "tabs.feedback" },
  { to: "/admin/generations", key: "tabs.generations" },
  { to: "/admin/audit-log", key: "tabs.audit_log" },
];

export function AdminTabs(): JSX.Element {
  const { t } = useTranslation("admin");
  return (
    <nav style={WRAP}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          style={({ isActive }) => (isActive ? PILL_ACTIVE : PILL_BASE)}
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
